module.exports = __webpack_public_path__ + "static/media/user07.994502ce.png";